import { webActions } from "../../context";
import { useWeb } from "../useContext";

export const useLoadingFS = () => {
  const { loading, dispatch } = useWeb();
  const { setLoading } = webActions(dispatch);

  return { isLoading: loading, setLoading };
};
